import {
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonIcon,
  IonTitle,
  IonContent,
  IonGrid,
} from '@ionic/react';
import React, { FC } from 'react';
import { close } from 'ionicons/icons';

interface ModalWrapperProps {
  title: string;
  children: React.ReactNode;
  onDismiss?: () => void;
  contentClass?: string;
  gridClass?: string;
  endSlot?: React.ReactNode;
}

const ModalWrapper: FC<ModalWrapperProps> = ({
  title,
  children,
  onDismiss,
  contentClass,
  gridClass,
  endSlot,
}) => (
  <>
    <IonHeader>
      <IonToolbar mode="ios">
        {onDismiss && (
          <IonButtons slot="start">
            <IonButton onClick={onDismiss}>
              <IonIcon icon={close} />
            </IonButton>
          </IonButtons>
        )}
        {endSlot && <IonButtons slot="end">{endSlot}</IonButtons>}
        <IonTitle>{title}</IonTitle>
      </IonToolbar>
    </IonHeader>
    <IonContent className={contentClass}>
      <IonGrid fixed className={gridClass}>
        {children}
      </IonGrid>
    </IonContent>
  </>
);

export default ModalWrapper;
